import React from "react";
import BaseList from "../Common/BaseList";
// import { Link } from 'react-router-dom';
// import { Icon } from 'antd';
import { Button } from "antd";
import { Link } from "react-router-dom";

class List extends BaseList {
  constructor() {
    super();
    this.columns = [
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Item #
          </div>
        ),
        dataIndex: "productCode",
        className: "list-data",
        key: "productCode",
        align: "left",
        width: "120px",
        // sorter: true,
        render: (data) => <div style={{ color: "black" }}>{data}</div>,
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Photos
          </div>
        ),
        dataIndex: "image",
        className: "list-data",
        key: "image",
        align: "left",
        width: "150px",
        render: (data) => (
          <img
            src={data}
            style={{ width: "75px", height: "75px", borderRadius: "10px" }}
            alt="product icon"
          />
        ),
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Name
          </div>
        ),
        dataIndex: "productName",
        className: "list-data",
        key: "productName",
        align: "left",
        width: "200px",
        // sorter: true,
        render: (data) => <div style={{ color: "black" }}>{data}</div>,
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Description
          </div>
        ),
        dataIndex: "description",
        className: "list-data",
        key: "description",
        align: "left",
        width: "350px",
        // sorter: true,
        render: (data) => <div style={{ color: "black" }}>{data}</div>,
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Sizes & Prices
          </div>
        ),
        dataIndex: "sizes",
        className: "list-data",
        key: "size",
        align: "left",
        // width: '400px',
        render: (data, row) => (
          // <Link to={ "" } >
          //   <Icon type='eye' theme='filled' />
          // </Link>
          <span
            onClick={() => this.props.modalData(data, row)}
            style={{
              cursor: "pointer",
              color: "#1890ff",
              textDecoration: "underline",
            }}
          >
            Details
          </span>
        ),
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Actions
          </div>
        ),
        dataIndex: "id",
        key: "id",
        render: (id, record) => (
          <div style={{ display: "flex" }}>
            <Button
              style={{
                backgroundColor: "#0E4D90",
                borderColor: "#0E4D90",
                color: "#FFF",
              }}
            >
              <Link to={"/app/products/editproduct/" + id}>Edit</Link>
            </Button>
            {/* <Button  style={{backgroundColor: "#CD5C5C", borderColor: "#CD5C5C", color: "#FFF", marginLeft: "10px"}} onClick={()=>{ if (window.confirm('Are you sure you want to delete this product?')) this.props.deleteProduct(id)}}>
                Delete
            </Button> */}
            {record.isActive ? (
              <Button
                style={{
                  backgroundColor: "#CD5C5C",
                  borderColor: "#CD5C5C",
                  color: "#FFF",
                  marginLeft: "10px",
                }}
                onClick={() => {
                  if (
                    window.confirm(
                      "Are you sure you want to deactivate this product?"
                    )
                  )
                    this.props.changeStatus(false, id);
                }}
              >
                De-activate
              </Button>
            ) : (
              <Button
                style={{
                  backgroundColor: "green",
                  borderColor: "green",
                  color: "#FFF",
                  marginLeft: "10px",
                }}
                onClick={() => {
                  this.props.changeStatus(true, id);
                }}
              >
                Re-activate
              </Button>
            )}
          </div>
        ),
      },
    ];
  }
}

export default List;
